import RedirectTo from '@/components/redirect-to'
import uniqueIds from '@/config/unique-ids.json'
import Login from '@/pages/login'
import SuzhouLogin from '@/pages/suzhou-login'
import { getUniqueId } from '@/project-config'
import { CommonObject, CusRouteConfig } from '@yuanfudao/metis-unified-login'
import qs from 'qs'
import React from 'react'

const DesignationLogin = React.lazy(() => import('@/pages/designation-login'))
const DesignationStudentLogin = React.lazy(() => import('@/pages/designation-student-login'))
const TokenLogin = React.lazy(() => import('@/pages/token-login'))
const OpenLogin = React.lazy(() => import('@/pages/open-login'))
const OpenLoginV2 = React.lazy(() => import('@/pages/open-login-v2'))
const Unbind = React.lazy(() => import('@/pages/unbind'))
const Embed = React.lazy(() => import('@/pages/embed'))
const LoginPage = getUniqueId() === uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id ? SuzhouLogin : Login

const routes: CusRouteConfig[] = [
  {
    path: '/login/:param?',
    name: 'login',
    exact: true,
    component: LoginPage,
  },
  {
    path: '/designation-login',
    name: 'designationLogin',
    exact: true,
    component: DesignationLogin,
  },
  {
    path: '/designation-student-login',
    name: 'designationStudentLogin',
    exact: true,
    component: DesignationStudentLogin,
  },
  {
    path: '/token-login',
    name: 'tokenLogin',
    exact: true,
    component: TokenLogin,
  },
  {
    path: '/embed/:type',
    name: 'embed',
    exact: true,
    component: Embed,
  },
  {
    path: '/nydus',
    name: 'nydus',
    exact: true,
    component: OpenLogin,
  },
  {
    path: '/nydus-v2',
    name: 'nydus',
    exact: true,
    component: OpenLoginV2,
  },
  {
    path: '/open-login',
    name: 'OpenLogin',
    exact: true,
    component: OpenLogin,
  },
  {
    path: '/',
    name: 'root',
    exact: true,
    component: RedirectTo,
  },
  {
    path: '/unbind',
    name: 'Unbind',
    exact: true,
    component: Unbind,
  },
]

const urlMap: CommonObject<string> = {}
const paramReg = /:\w+/g

function traverse(cusRouteConfigs: CusRouteConfig[]) {
  for (const route of cusRouteConfigs) {
    if (route.name) {
      urlMap[route.name] = route.path as string
    }
    if (route.routes) {
      traverse(route.routes)
    }
  }
}
traverse(routes)

// 直接使用 path 来导航的话，如果以后 path 需要改变的话会很麻烦，所以改用 name 的方式来导航
export function resolveRoute(route: {name: string, params?: CommonObject<any>, query?: CommonObject<any>}) {
  const { name, params, query } = route
  let path = urlMap[name]
  if (!path) {
    return ''
  }
  const paramsList = path.match(paramReg)
  if (params && paramsList) {
    paramsList.forEach((p) => {
      const key = p.slice(1)
      path = path.replace(p, params[key])
    })
  }
  if (query) {
    path = `${path}?${qs.stringify(query, { arrayFormat: 'repeat' })}`
  }
  if (name === 'login') {
    path = path.slice(0, -1)
  }

  return path
}

export default routes
